import * as types from 'store/moderator/moderatorTypes'

const initialState = {
   moderatorDetails:{ moderatorBuffer : '', lastUpdatedOn : '' },
   moderatorBufferIsSubmitting: false
}

/*
  Would like to move to ramda at a later point or use in other parts of app
  however if we want proper type coverage, we need to wait for the definitions to
  be finished for the latest release of flow and/or ramda.
  In the interim, Object.assign will be fine.
*/
const moderatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_BUFFER_SUCCEEDED:
      return {
        ...state,
        moderatorDetails:{ moderatorBuffer:action.payload.moderatorBuffer , lastUpdatedOn: action.payload.moderatorBufferModifiedOn }
      }
    case types.UPDATE_MODERATOR_DETAILS_SUCCEEDED:
       return { ...state, moderatorDetails: { moderatorBuffer: action.payload.value, lastUpdatedOn: action.payload.lastUpdatedOn }, moderatorBufferIsSubmitting: false }
    case types.UPDATE_MODERATOR_DETAILS_REQUESTED:
      return { ...state, moderatorBufferIsSubmitting: true }
    case types.UPDATE_MODERATOR_DETAILS_FAILED:
      return { ...state, moderatorBufferIsSubmitting: false }  
    default:
      return state
  }
}

export default moderatorReducer